module.exports = __webpack_public_path__ + "public/SiteIcons/editingWishIcon.svg?14c95204";